import {Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {getNotifications} from "../../services/notification/notification";
import {NotificationGrid} from "./grid";
import {NotificationForm} from "./form";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {PaginateContext} from "../../context/paginate";
import {NotificationContext} from "../../context/notification";

export function NotificationManagement() {

  const [notifications, setNotifications] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getNotifications(paginate);
    if (result.status === 200) {
      const {notificationList, total_count} = result.data;
      setNotifications(notificationList || []);
      setGridTotalRowCount(total_count);
      if (localStorage.hasOwnProperty("selectedNotification")) {
        setGridSelectedRow(notificationList.filter(item => item.id === parseInt(localStorage.getItem("selectedNotification")))[0]);
        setModalOpen(true);
        localStorage.removeItem("selectedNotification");
      }
    }
  }


  useEffect(() => {
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <NotificationContext.Provider value={{
      notifications: notifications,
      setNotifications: setNotifications,
      modalOpen: modalOpen,
      setModalOpen: setModalOpen,
      notification: gridSelectedRow,
      setNotification: setGridSelectedRow,
    }}>
      <PaginateContext.Provider value={{
        setSortBy: setSortBy,
        sortType: sortType,
        setSortType: setSortType,
        active: gridCurrentPage,
        setActive: setGridCurrentPage,
        totalRows: gridTotalRowCount,
        setTotalRows: setGridTotalRowCount,
        rowsCount: gridRowCount,
        setRowsCount: setGridRowCount,
        from: from,
        to: to,
      }}>
        <div className="">
          <NotificationForm notification={gridSelectedRow} open={modalOpen} setOpen={setModalOpen}
                            setGridSelectedRow={setGridSelectedRow}/>
          <Card className="pt-8">
            <CardHeader floated={true} shadow={false} className="rounded-none">
              <Typography variant="h5" color="blue-gray">پیام‌ها</Typography>
            </CardHeader>
            <CardBody className="overflow-x-scroll w-screen-64">
              <NotificationGrid/>
            </CardBody>
            <CardFooterPaginator/>
          </Card>
        </div>
      </PaginateContext.Provider>
    </NotificationContext.Provider>
  )
    ;
}